import 'swiper/swiper-bundle.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import common from './common/function'
import http from './http'
import router from './router'
import store from './store'

import 'video.js/dist/video-js.css'

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper /* { default options with global component } */)
Vue.use(Vant)
Vue.use(VueI18n)
const FIXED_DOMAIN = "https://www.vvxsdv.com";
function formatImgUrl(url) {
  if (!url) return ""

  // ✅ 1. 已经是完整 URL（http / https） → 直接返回
  if (/^https?:\/\//.test(url)) {
    // 开发环境替换 localhost
    if (process.env.NODE_ENV === 'development') {
      return url.replace(/^https?:\/\/localhost:\d+/, FIXED_DOMAIN)
    }
    return url
  }

  // ✅ 2. 开发环境
  if (process.env.NODE_ENV === 'development') {
    if (url.startsWith("/")) {
      return FIXED_DOMAIN + url
    }
  }

  // ✅ 3. 生产环境（补全域名）
  return window.location.protocol + '//' + window.location.host + url
}
// 图片前缀
Vue.prototype.$formatImgUrl = formatImgUrl;

const i18n = new VueI18n({
  globalInjection: true,
  locale: localStorage.getItem('lang') || 'en_us', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  fallbackLocale: 'en_us', // 回退语言
  silentTranslationWarn: true, // 静默翻译警告
  messages: {
    zh_cn: require('./assets/languages/zh_cn.json'),
    en_us: require('./assets/languages/en_us.json'),
    es_spa: require('./assets/languages/es_spa.json'),
    ms_my: require('./assets/languages/ms_my.json'),
    de: require('./assets/languages/de.json'),
  },
})

// 确保语言设置正确
const savedLang = localStorage.getItem('lang')
console.log('保存的语言:', savedLang)
if (savedLang && ['zh_cn', 'en_us', 'es_spa', 'ms_my', 'de'].includes(savedLang)) {
  i18n.locale = savedLang
  console.log('设置语言为:', savedLang)
} else {
  // 如果没有保存的语言或语言无效，设置为默认语言
  i18n.locale = 'zh_cn'
  localStorage.setItem('lang', 'zh_cn')
  console.log('设置默认语言为: zh_cn')
}

// 添加全局语言切换方法
Vue.prototype.$changeLanguage = function (lang) {
  try {
    console.log('全局语言切换方法被调用，目标语言:', lang)
    this.$i18n.locale = lang
    localStorage.setItem('lang', lang)
    console.log('语言切换完成，当前语言:', this.$i18n.locale)
    // 强制更新所有组件
    this.$forceUpdate()
  } catch (error) {
    console.error('语言切换失败:', error)
  }
}

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
  mounted() {
    console.log('Vue应用挂载完成，当前语言:', this.$i18n.locale)
  },
}).$mount('#app')
